import {FC} from "react";
import {useForm} from "antd/es/form/Form";
import {DepartmentModalProps} from "./types";
import {Modal} from "antd";
import DepartmentFrom from "./department-form/DepartmentForm";

const DepartmentModal: FC<DepartmentModalProps> = (props) => {
  const {isModalOpen, toggleModalOpen, isLoading, selectedDepartment, createDepartment, updateDepartment} = props
  const [form] = useForm()
  const okButtonHandler = () => {
    form.submit()
  }
  const title = selectedDepartment ? "Редагувати відділення" : "Створити відділення"
  return <Modal destroyOnClose style={{top: 20}} width={1000} title={title} open={isModalOpen}
                onCancel={toggleModalOpen}
                okText="Збереги" onOk={okButtonHandler}>
    <DepartmentFrom updateDepartment={updateDepartment} isLoading={isLoading} createDepartment={createDepartment}
                    form={form}
                    selectedDepartment={selectedDepartment}/>
  </Modal>
}

export default DepartmentModal